import { Component, OnInit, AfterViewInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { filter, Subscription, take } from 'rxjs';

import { SessionService } from '../../service/session.service';

import * as constant from '../../models/constant';

declare function resetCommonrEvent(): void;
declare function howto_accordion(): void;

@Component({
  selector: 'app-howto',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './howto.component.html',
  styleUrls: ['./howto.component.scss']
})
export class HowtoComponent implements OnInit, AfterViewInit {

  public is_additional: boolean = false; // 送料区分判定（true:送料別、false:送料込み）
  private subscription: Subscription = new Subscription();

  constructor(
    private sv_session: SessionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {
    this.sv_session.loginCheck();
    this.subscription.add (
      this.sv_session.safeSessionState.pipe(
        filter(_ => this.sv_session.sessionReadySubject.value),
        take(1)
      ).subscribe(session => {
        if (!session || !session.data) {
          this.sv_session.logout();
        } else {
          this.is_additional = session.data.delive_fee_type == constant.CAMPANY_DELIVE_FEE_TYPE.ADDITIONAL;
        }
      })
    );
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        resetCommonrEvent();
        howto_accordion();
      }, 0);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
